// extracted by mini-css-extract-plugin
export default {"zone":"YRy34NUS","disabledZone":"S8MlRdR2"};